import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue'
import {getUserId} from '../../util/auth'
import { Userspaces } from '@busy-human/opt-library'
import { useUserspace } from '@/store/userspace';

type Emits = {
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'payment-setup',
  emits: ["progress"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();



const amount = ref(50);
const userspace = useUserspace();

let updateDefaultRate = async() =>{
    let user = userspace.user;

    let userUpdates: Partial<Userspaces.Model> = {
        defaultRate: {
            minutes: 30,
            price: amount.value
        }
    }

    let userSetupCompleted = user.setupCompleted
    if(!userSetupCompleted.includes('RATE')){
        userSetupCompleted.push('RATE')
        userUpdates['setupCompleted'] = userSetupCompleted
    }

    Userspaces.Collection.updateDoc(userspace.uid, userUpdates)
    emit('progress')

}



const __returned__ = { emit, amount, userspace, updateDefaultRate, ref, onMounted, computed, getUserId, Userspaces, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})